import AddIcon from "../../components/Icons/AddIcon";
import Button from "../../components/Shared/Button";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getCertificates } from "../../api/Certificates/GetAllCertificates";
import Spinner from "../../components/Shared/Spinner";
import AddCertificate from "../../components/Dashboard/Certificates/AddCertificate";
import ThreeDotsIcon from "../../components/Icons/ThreeDotsIcon";
import CertificateDropdown from "../../components/Dashboard/Certificates/CertificateDropdown";
const ExamGenerator = () => {
    const [showAddCertificate, setShowAddCertificate] = useState(false);
    const { data: CertificatesResponse, isLoading: isCertificateLoading } = useQuery({
        queryFn: getCertificates,
        queryKey: ["certificates"],
        staleTime: 0,
        refetchInterval: 0,
    });
    const certificates = CertificatesResponse?.data?.certificatesData ?? [];
    const handleAddCertificateSuccess = () => {
        setShowAddCertificate(false);
    };


    if (isCertificateLoading)
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Spinner />
            </div>
        );

    return (
        <div>
            {showAddCertificate ? (
                <AddCertificate onSuccess={handleAddCertificateSuccess} />
            ) : (
                <div className="space-y-6">
                    <div className="bg-white my-7 p-4 rounded-lg">
                        <div className="flex justify-between items-center  border-b pb-5 mb-4">
                            <h1 className="text-burntBlack font-bold text-[32px]">Certificates</h1>
                            <Button
                                onClick={() => setShowAddCertificate(true)}
                                className="!h-12 w-52 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                                variant="primary"
                            >
                                <AddIcon className="mr-1.5" />
                                Add New Certificate
                            </Button>
                        </div>
                        <div className="grid grid-cols-3 place-content-between gap-4 pb-10">
                            {certificates?.map((certificate) => (
                                <div className="p-4 bg-white rounded-2xl w-[364px] relative flex flex-col justify-between">
                                    <div className="relative mb-4">
                                        <img
                                            className="max-w-[332px] max-h-[225px] w-full h-full object-fit rounded-lg border-[#C4C4C4]/15 border"
                                            src={certificate.img_url}
                                            alt="Course"
                                        />
                                    </div>
                                    <div>
                                        <div className="flex justify-between w-full items-center mb-3 py-0.5">
                                            <h1 className="font-semibold text-2xl">{certificate.name}</h1>
                                        </div>
                                        <div className=" mb-4">
                                            <span className="font-medium text-sm text-lightGray/70">
                                                <p>{certificate.description}</p>
                                            </span>

                                        </div>
                                    </div>
                                    <div className="absolute bottom-4 right-4 z-10">
                                        <CertificateDropdown  certificateId={certificate.id}>
                                            <ThreeDotsIcon />
                                        </CertificateDropdown>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            )}
        </div>
    );
};

export default ExamGenerator;
